<script>
	
	import {API} from '../global.js'

	export let data = {}

	let oper_ds = []
	let loading = false
	let activas = true

	let anu = ['ANUAL','IMPAR','PAR']

	const refresh = async () => {
		loading = true
		let rs = await fetch(`${API}/cliente-operaciones/${data.info.IdCliente}`)
		let ds = await rs.json()
		oper_ds = ds
		loading = false
	}

	refresh()

</script>

<div class="container-fluid">

{#if loading}
	<p>Loading</p>
{:else}
	<br>
	Activas&nbsp;<input type=checkbox bind:checked={activas}>
	<table class="table table-sm">
		<thead>
			<tr>
				<th>IdOperacion</th>
			    <th>Hotel</th>
			    <th>Sem</th>
			    <th>Temp</th>
			    <th>Producto</th>
			    <th>Bienal</th>
			    <th>Puntos</th>
			    <th>Estado</th>
			    <th>Contrato</th>
			    <th>Contable</th>
			    <th>Activo</th>
			    <!--
			    <th>FechaReserva</th>
			    <th>IdHotel</th>
			    <th>IdTemporada</th>
			    <th>PuntosPosibles</th>
			    <th>FechaBaja</th>
			    <th>IdProducto</th>
			    <th>IdTipoOperacion</th>
			    <th>TipoOperacion</th>
			    <th>IdPaisVenta</th>
			    <th>PaisVenta</th>
			    <th>IdSociedad</th>
			    <th>Sociedad</th>
			    <th>IdProcedencia</th>
			    <th>Procedencia</th>
				-->
			</tr>
		</thead>
		<tbody>
			{#each oper_ds.data as oper, index}
				{#if !activas || oper.activo}
					<tr style="{!oper.activo?'color: #999;':''}">
						<td>{oper.IdOperacion}</td>
					    <td>{oper.hotel}</td>
					    <td>{oper.IdSemana}</td>
					    <td>{oper.Temporada}</td>
					    <td>{oper.Producto}</td>
					    <td>{anu[oper.Bienal]}</td>
					    <td>{oper.Puntos}</td>
					    <td>{oper.Estado}</td>
					    <td>{oper.FechaContrato || '00-00-0000'}</td>
					    <td>{oper.FechaContable  || '00-00-0000'}</td>
					    <td>{oper.activo} {oper.vip?'vip':''}</td>
					</tr>
				{/if}
			{/each}	
		</tbody>		
		
	</table>
<!--
	<pre>{JSON.stringify(oper_ds.data,null,2)}</pre>
-->	
{/if}

</div>